export const FETCH_TALENTS = '@@talents/FETCH_REQUEST';
export const FETCH_TALENTS_SUCCESS = '@@talents/FETCH_SUCCESS';
export const FETCH_TALENTS_FAILURE = '@@talents/FETCH_FAILURE';

export const SEARCH_TALENTS = '@@talents/SEARCH_REQUEST';
export const SEARCH_TALENTS_SUCCESS = '@@talents/SEARCH_SUCCESS';
export const SEARCH_TALENTS_FAILURE = '@@talents/SEARCH_FAILURE';

export const SET_TALENTS_PAGE = '@@talents/SET_PAGE';
export const SET_TALENTS_SIZE = '@@talents/SET_SIZE';
export const SET_TALENTS_TOTAL = '@@talents/SET_TOTAL';

export const RESET_TALENTS_STATE = '@@talent/RESET_TALENTS_STATE';
